import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';

import SlideThumbnail from './SlideThumbnail';

const propTypes = {
  style: PropTypes.object.isRequired,
  video: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

const VideoSlideshowThumbnailSortable = ({ style, video, ...props }) => {
  const { isDragging, setNodeRef, attributes, listeners } = useSortable({
    id: video?.id,
    data: {
      video,
    },
  });

  const classes = classNames({
    'secondary-photos-view-slides-step-slide-thumbnail-sortable': true,
  });

  const thumbnailClasses = classNames({
    'is-dragging': isDragging,
  });

  return (
    <div
      style={style}
      className={classes}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <SlideThumbnail video={video} className={thumbnailClasses} {...props} />
    </div>
  );
};
VideoSlideshowThumbnailSortable.propTypes = propTypes;

export default VideoSlideshowThumbnailSortable;
